module.exports = __webpack_public_path__ + "img/explain.95e44ee2.png";